/**
 * @author       matt@zumper.com (Matthieu Devlin)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  constants for traktor-middleware
 */

/* istanbul ignore file */

export const AFFORDABILITY_CALCULATOR_MESSAGE = 'AFFORDABILITY_CALCULATOR_MESSAGE'
export const AFFORDABILITY_CALCULATOR_MULTI_MESSAGE = 'AFFORDABILITY_CALCULATOR_MULTI_MESSAGE'
export const AFFORDABILITY_CALCULATOR_MULTI_MESSAGE_IMPRESSION =
  'AFFORDABILITY_CALCULATOR_MULTI_MESSAGE_IMPRESSION'
export const CLICK_MESSAGE = 'CLICK_MESSAGE'
export const CLICK_TOUR_AVAILABILITY = 'CLICK_TOUR_AVAILABILITY'
export const DATE_PICKER_CLICK = 'DATE_PICKER_CLICK'
export const DATE_PICKER_IMPRESSION = 'DATE_PICKER_IMPRESSION'
export const DETAIL_ALERT = 'DETAIL_ALERT'
export const DETAIL_BOOK = 'DETAIL_BOOK'
export const DETAIL_CALL = 'DETAIL_CALL'
export const DETAIL_DISLIKE = 'DETAIL_DISLIKE'
export const DETAIL_FAVORITE = 'DETAIL_FAVORITE'
export const DETAIL_IMPRESSION = 'DETAIL_IMPRESSION'
export const DETAIL_MESSAGE = 'DETAIL_MESSAGE'
export const DETAIL_MESSAGE_SIMILAR = 'DETAIL_MESSAGE_SIMILAR'
export const DETAIL_MULTI_MESSAGE = 'DETAIL_MULTI_MESSAGE'
export const DETAIL_MULTI_MESSAGE_IMPRESSION = 'DETAIL_MULTI_MESSAGE_IMPRESSION'
export const DETAIL_MULTI_MESSAGE_SIMILAR = 'DETAIL_MULTI_MESSAGE_SIMILAR'
export const DETAIL_MULTI_MESSAGE_SIMILAR_IMPRESSION = 'DETAIL_MULTI_MESSAGE_SIMILAR_IMPRESSION'
export const DETAIL_OFFPLATFORM_CLICK = 'DETAIL_OFFPLATFORM_CLICK'
export const DETAIL_SHARE = 'DETAIL_SHARE'
export const EMAIL_ENTERED = 'EMAIL_ENTERED'
export const FLOORPLAN_CLICK = 'FLOORPLAN_CLICK'
export const FLOORPLAN_SELECTED = 'FLOORPLAN_SELECTED'
export const HOMEPAGE_IMPRESSION = 'HOMEPAGE_IMPRESSION'
export const EXPLORE_RENTALS_IMPRESSION = 'EXPLORE_RENTALS_IMPRESSION'
export const APP_DOWNLOAD_IMPRESSION = 'APP_DOWNLOAD_IMPRESSION'
export const RENT_REPORT_IMPRESSION = 'RENT_REPORT_IMPRESSION'
export const POPULAR_CITIES_IMPRESSION = 'POPULAR_CITIES_IMPRESSION'
export const LIST_YOUR_PROPERTY_IMPRESSION = 'LIST_YOUR_PROPERTY_IMPRESSION'
export const PRESS_IMPRESSION = 'PRESS_IMPRESSION'
export const FAQ_IMPRESSION = 'FAQ_IMPRESSION'
export const EXPLORE_RENTALS_VIEW_ALL_CLICK = 'EXPLORE_RENTALS_VIEW_ALL_CLICK'
export const POPULAR_CITIES_CLICK = 'POPULAR_CITIES_CLICK'
export const APP_DOWNLOAD_CLICK = 'APP_DOWNLOAD_CLICK'
export const LIST_YOUR_PROPERTY_CLICK = 'LIST_YOUR_PROPERTY_CLICK'
export const IDENTIFY = 'IDENTIFY'
export const INITIAL_PAGE_LOAD = 'INITIAL_PAGE_LOAD'
export const LISTING_SELECTED = 'LISTING_SELECTED'
export const LIST_CARD_CLICK = 'LIST_CARD_CLICK'
export const LIST_CAROUSEL_CLICK = 'LIST_CAROUSEL_CLICK'
export const LIST_ITEM_CALL = 'LIST_ITEM_CALL'
export const LIST_ITEM_CLICK = 'LIST_ITEM_CLICK'
export const LIST_ITEM_DISLIKE = 'LIST_ITEM_DISLIKE'
export const LIST_ITEM_FAVORITE = 'LIST_ITEM_FAVORITE'
export const LIST_ITEM_IMPRESSION = 'LIST_ITEM_IMPRESSION'
export const LIST_ITEM_MESSAGE = 'LIST_ITEM_MESSAGE'
export const LIST_ITEM_MULTI_MESSAGE = 'LIST_ITEM_MULTI_MESSAGE'
export const LIST_ITEM_MULTI_MESSAGE_IMPRESSION = 'LIST_ITEM_MULTI_MESSAGE_IMPRESSION'
export const LIST_ITEM_SHARE = 'LIST_ITEM_SHARE'
export const MAP_LIST_FILTER_BAR_CLICK = 'MAP_LIST_FILTER_BAR_CLICK'
export const MAP_LIST_AMENITY_SEARCH = 'MAP_LIST_AMENITY_SEARCH'
export const MESSAGE_IMPRESSION = 'MESSAGE_IMPRESSION'
export const MOVE_IN_ENTERED = 'MOVE_IN_ENTERED'
export const NAME_ENTERED = 'NAME_ENTERED'
export const NAVBAR_CLICK = 'NAVBAR_CLICK'
export const PAID_LANDING_FILTER_SUBMIT = 'PAID_LANDING_FILTER_SUBMIT'
export const PIN_CLICK = 'PIN_CLICK'
export const PERFORMANCE_METRICS_PAINT = 'PERFORMANCE_METRICS_PAINT'
export const PERMANENT_ADDRESS_MESSAGE = 'PERMANENT_ADDRESS_MESSAGE'
export const PHONE_ENTERED = 'PHONE_ENTERED'
export const PROGRAMMATIC_RENT_MULTI_MESSAGE = 'PROGRAMMATIC_RENT_MULTI_MESSAGE'
export const PROGRAMMATIC_RENT_MULTI_MESSAGE_IMPRESSION =
  'PROGRAMMATIC_RENT_MULTI_MESSAGE_IMPRESSION'
export const RELATED_MM_FAVORITE = 'RELATED_MM_FAVORITE'
export const RENT_HISTORY_IMPRESSION = 'RENT_HISTORY_IMPRESSION'
export const LOCATION_CHANGE = 'LOCATION_CHANGE'
export const MAP_LIST_ALERT = 'MAP_LIST_ALERT'
export const MAP_LIST_NO_RESULTS = 'MAP_LIST_NO_RESULTS'
export const SEARCH_QUESTIONS_EMAIL_CAPTURE = 'SEARCH_QUESTIONS_EMAIL_CAPTURE'
export const SHORT_TERM_CLICK_OUT = 'SHORT_TERM_CLICK_OUT'
export const TOUR_BOOKING_IMPRESSION = 'TOUR_BOOKING_IMPRESSION'
export const TOUR_BOOKING_START_IMPRESSION = 'TOUR_BOOKING_START_IMPRESSION'
export const TOUR_BOOKING_START_CLICK = 'TOUR_BOOKING_START_CLICK'
export const TOUR_BOOKING_EXIT_CLICK = 'TOUR_BOOKING_EXIT_CLICK'
export const TOUR_BOOKING_NEXT_CLICK = 'TOUR_BOOKING_NEXT_CLICK'
export const TOUR_BOOKING_EDIT_CLICK = 'TOUR_BOOKING_EDIT_CLICK'
export const TOUR_BOOKING_SUBMIT_CLICK = 'TOUR_BOOKING_SUBMIT_CLICK'
export const TOUR_BOOKING_SEND_MESSAGE_CLICK = 'TOUR_BOOKING_SEND_MESSAGE_CLICK'
export const SEARCH_QUESTIONS_COMPLETION = 'SEARCH_QUESTIONS_COMPLETION'
export const UNDO_MESSAGE = 'UNDO_MESSAGE'
export const UNDO_TOUR = 'UNDO_TOUR'
export const UNKNOWN_MESSAGE = 'UNKNOWN_MESSAGE'
export const USER_MENU_CLICK = 'USER_MENU_CLICK'
export const QUICK_LOOK_CLICK = 'QUICK_LOOK_CLICK'
export const LINKPACK_LINK_CLICKED = 'LINKPACK_LINK_CLICKED'
export const EXPLORE_RENTALS_TAB_CLICK = 'EXPLORE_RENTALS_TAB_CLICK'
export const VERTICAL_GALLERY_IMPRESSION = 'VERTICAL_GALLERY_IMPRESSION'
export const FOCUSED_GALLERY_IMPRESSION = 'FOCUSED_GALLERY_IMPRESSION'
export const SEARCH_BAR_CLICK = 'SEARCH_BAR_CLICK '
export const FILTER_CHANGE = 'FILTER_CHANGE'
export const LIFESTYLE_PREV_CLICK = 'LIFESTYLE_PREV_CLICK'
export const LIFESTYLE_NEXT_CLICK = 'LIFESTYLE_NEXT_CLICK'
export const LIFESTYLE_SUMMARY_READ_MORE_CLICK = 'LIFESTYLE_SUMMARY_READ_MORE_CLICK'
export const LIFESTYLE_SUMMARY_RATING_LEARN_MORE_CLICK = 'LIFESTYLE_SUMMARY_RATING_LEARN_MORE_CLICK'
export const LIFESTYLE_SUMMARY_YOULL_LOVE_LEARN_MORE_CLICK =
  'LIFESTYLE_SUMMARY_YOULL_LOVE_LEARN_MORE_CLICK'
export const LIFESTYLE_SUMMARY_GREAT_FOR_LEARN_MORE_CLICK =
  'LIFESTYLE_SUMMARY_GREAT_FOR_LEARN_MORE_CLICK'
// map poi
export const MAP_LIST_POI = 'MAP_LIST_POI'
export const MAP_LIST_POI_APPLY_BUTTON_CLICK = 'MAP_LIST_POI_APPLY_BUTTON_CLICK'
export const MAP_LIST_POI_CATEGORY_BUTTON_CLICK = 'MAP_LIST_POI_CATEGORY_BUTTON_CLICK'
export const MAP_LIST_POI_CLEAR_BUTTON_CLICK = 'MAP_LIST_POI_CLEAR_BUTTON_CLICK'
export const MAP_LIST_POI_NEARBY_BUTTON_CLICK = 'MAP_LIST_POI_NEARBY_BUTTON_CLICK'
export const MAP_LIST_POI_MAP_MARKER_PIN_CLICK = 'MAP_LIST_POI_MAP_MARKER_PIN_CLICK'
export const MAP_LIST_POI_MAP_MARKER_POPOVER_CLOSE_CLICK =
  'MAP_LIST_POI_MAP_MARKER_POPOVER_CLOSE_CLICK'
export const MAP_LIST_POI_RESULTS = 'MAP_LIST_POI_RESULTS'
export const MAP_LIST_TOGGLE_CLICK = 'MAP_LIST_TOGGLE_CLICK'

// ai assistant
export const ZOE_ENTRY_CLICK = 'ZOE_ENTRY_CLICK'
export const ZOE_ENTRY_IMPRESSION = 'ZOE_ENTRY_IMPRESSION'
export const ZOE_TOGGLE_CLICK = 'ZOE_TOGGLE_CLICK'
export const ZOE_DEFAULT_QUESTION_SUGGESTION_CLICK = 'ZOE_DEFAULT_QUESTION_SUGGESTION_CLICK'
export const ZOE_FOLLOW_UP_QUESTION_SUGGESTION_CLICK = 'ZOE_FOLLOW_UP_QUESTION_SUGGESTION_CLICK'
export const ZOE_QUESTION_SEND = 'ZOE_QUESTION_SEND'
export const ZOE_NO_RESULT = 'ZOE_NO_RESULT'
export const ZOE_CLOSE_CLICK = 'ZOE_CLOSE_CLICK'
export const ZOE_CHAT_INITIALIZED = 'ZOE_CHAT_INITIALIZED'

// Zoe map list
export const ZOE_ENTRY_FILTER_BAR_CLICK = 'ZOE_ENTRY_FILTER_BAR_CLICK'
export const ZOE_ENTRY_SEARCH_BAR_CLICK = 'ZOE_ENTRY_SEARCH_BAR_CLICK'
export const ZOE_SEARCH_QUERY_SEND = 'ZOE_SEARCH_QUERY_SEND'
export const ZOE_SAVED_QUESTION_SUGGESTION_CLICK = 'ZOE_SAVED_QUESTION_SUGGESTION_CLICK'

// Map List Split Toggle
export const MAP_LIST_SPLIT_TOGGLE_CLICK = 'MAP_LIST_SPLIT_TOGGLE_CLICK'
export const PIN_LISTING_CARD_CLICK = 'PIN_LISTING_CARD_CLICK'
export const FULL_WIDTH_MAP_IMPRESSION = 'FULL_WIDTH_MAP_IMPRESSION'

// AFR rent content
export const RENT_PRICE_CLICK = 'RENT_PRICE_CLICK'
export const RENT_CALCULATOR = 'RENT_CALCULATOR'

// Airbnb-friendly Internal Ad Module
export const AIRBNB_VIEW_PROPERTIES_CLICK = 'AIRBNB_VIEW_PROPERTIES_CLICK'
export const AIRBNB_LEARN_MORE_CLICK = 'AIRBNB_LEARN_MORE_CLICK'
// Unloadable media
export const VIRTUAL_TOUR_IMPRESSION_FAILED = 'VIRTUAL_TOUR_IMPRESSION_FAILED'
